import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Select,
  Switch,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import ReactSelect from "react-select";
import { selectStyles } from "../../utils/selectStyel";

export const AddRepeatAbleItemModal = ({
  isOpen,
  onClose,
  fieldData,
  onSave,
}) => {
  const { register, handleSubmit, reset, control, watch } = useForm();
  const [subgroupOptions, setSubgroupOptions] = useState([]);
  const type = watch("TYPE");
  useEffect(() => {
    async function fetchConfig() {
      try {
        const res = await fetch("/api/listConfig?type=CODE");
        const data = await res.json();
        const options = data.map((item) => ({
          value: item.id,
          label: item.DESCRIPTION || item.id,
        }));
        setSubgroupOptions(options);
      } catch (err) {
        console.error("Failed to fetch subgroup options", err);
      }
    }
    fetchConfig();
  }, []);

  useEffect(() => {
    // Pre-fill REFERENCE if present
    const data = { ...fieldData };
    if (fieldData?.REFERENCE) {
      data.REFERENCE_TIMESTAMP = fieldData.REFERENCE.TIMESTAMP || "";
      data.REFERENCE_CODE = fieldData.REFERENCE.CODE || "";
      data.REFERENCE_SUBGROUP = fieldData.REFERENCE.SUBGROUP || "";
    }
    reset(data);
  }, [fieldData, reset]);

  const handleSave = (data) => {
    // Rebuild REFERENCE object if Dropdown
    if (data.TYPE === "Dropdown") {
      data.REFERENCE = {
        TIMESTAMP: data.REFERENCE_TIMESTAMP,
        CODE: data.REFERENCE_CODE,
        SUBGROUP: data.REFERENCE_SUBGROUP || undefined,
      };
      delete data.REFERENCE_TIMESTAMP;
      delete data.REFERENCE_CODE;
      delete data.REFERENCE_SUBGROUP;
    }
    onSave(data);
  };

  return (
    <Modal
      isOpen={isOpen}
      size="4xl"
      onClose={onClose}
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{fieldData ? "Edit Item" : "Add Item"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody maxHeight="78vh" overflowY="auto">
          <VStack align="stretch" spacing={4}>
            <HStack align="stretch" spacing={4}>
              <FormControl>
                <FormLabel>ID</FormLabel>
                <Input
                  {...register("SUBFIELD")}
                  placeholder="WRITE_HERE"
                  borderRadius="md"
                  borderColor="gray.300"
                  bg="white"
                />
              </FormControl>
              <FormControl>
                <FormLabel>Message</FormLabel>
                <Input
                  {...register("MESSAGE")}
                  borderRadius="md"
                  borderColor="gray.300"
                  bg="white"
                />
              </FormControl>
            </HStack>
            <HStack>
              <FormControl align="stretch" spacing={4}>
                <FormLabel>Tooltip</FormLabel>
                <Input
                  {...register("TOOLTIP")}
                  borderRadius="md"
                  borderColor="gray.300"
                  bg="white"
                />
              </FormControl>
              <FormControl>
                <FormLabel>CDC ID</FormLabel>
                <Input
                  {...register("CDC_ID")}
                  borderRadius="md"
                  borderColor="gray.300"
                  bg="white"
                />
              </FormControl>
            </HStack>

            <FormControl>
              <FormLabel>Type</FormLabel>
              <Select
                {...register("TYPE")}
                borderRadius="md"
                borderColor="gray.300"
                bg="white"
              >
                <option value="String">String</option>
                <option value="Dropdown">Dropdown</option>
                <option value="Number">Number</option>
                <option value="Date">Date</option>
                <option value="Boolean">Boolean</option>
                <option value="Multiselect">Multiselect</option>
              </Select>
            </FormControl>

            <Flex alignItems="center" gap={5}>
              <FormControl display="flex">
                <FormLabel>Editable</FormLabel>
                <Controller
                  control={control}
                  name="EDITABLE"
                  render={({ field: { value, onChange } }) => (
                    <Switch isChecked={value} onChange={onChange} />
                  )}
                />
              </FormControl>

              <FormControl display="flex">
                <FormLabel>Visible</FormLabel>
                <Controller
                  control={control}
                  name="VISIBLE"
                  render={({ field: { value, onChange } }) => (
                    <Switch isChecked={value} onChange={onChange} />
                  )}
                />
              </FormControl>
            </Flex>
            <Flex alignItems="center" gap={5}>
              {type === "Multiselect" && (
                <FormControl my={2}>
                  <FormLabel>Multiselect Type</FormLabel>
                  <Controller
                    control={control}
                    name="MULTISELECT_TYPE"
                    render={({ field }) => (
                      <RadioGroup {...field} size="lg">
                        <HStack spacing={2} alignItems="start">
                          <Radio value="Select_All_With_CheckBox">
                            Select All w/ Checkbox
                          </Radio>
                          <Radio value="Checkbox" fontWeight={500}>
                            Checkbox
                          </Radio>
                          <Radio value="Radio">Radio</Radio>
                        </HStack>
                      </RadioGroup>
                    )}
                  />
                </FormControl>
              )}
            </Flex>

            {(type === "Dropdown" || type === "Multiselect") && (
              <>
                <FormControl>
                  <FormLabel>Reference Code</FormLabel>
                  <Controller
                    control={control}
                    name="REFERENCE_CODE"
                    render={({ field }) => (
                      <ReactSelect
                        {...field}
                        options={subgroupOptions}
                        value={
                          subgroupOptions.find(
                            (opt) => opt.value === field.value
                          ) || null
                        }
                        onChange={(selected) =>
                          field.onChange(selected?.value || "")
                        }
                        placeholder="Select Code..."
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={selectStyles}
                      />
                    )}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Reference Subgroup</FormLabel>
                  <Input
                    {...register("REFERENCE_SUBGROUP")}
                    borderRadius="md"
                    borderColor="gray.300"
                    bg="white"
                  />
                </FormControl>
              </>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleSubmit(handleSave)}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
